import { render, staticRenderFns } from "./ourClients.vue?vue&type=template&id=77c5dc7b"
import script from "./ourClients.vue?vue&type=script&lang=js"
export * from "./ourClients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports